import { useEffect, useState } from 'react';
import { Grid2 as Grid } from '@mui/material';
import { useProjectDataContext } from 'domain/shared/newProject';
import { ProductionOwnership, ProjectEngineeringGraphqlData } from './types';
import { useQuery } from '@apollo/client/react';
import { PROJECT_ENGINEERING_TAB } from './graphql/engineeringQueries';
import { Loading } from 'framework/ui/mui-builder';
import { ControlledShow } from 'framework/show';
import ConfigurationLayout from './Configuration/ConfigurationLayout';
import IncidentsInProduction from './List/IncidentsInProduction';
import UserReportedBugs from './List/UserReportedBugs';
import { BugCrudProvider } from './CreateAndUpdateBug/BugCrudProvider';
import { IncidentCrudProvider } from './CreateAndUpdateIncident/IncidentCrudProvider';

const EngineeringContext = () => {
  const { data: projectData } = useProjectDataContext();
  const projectId = projectData?.id?.toString() ?? '';

  const { data, loading } = useQuery<{ baseProject: ProjectEngineeringGraphqlData }>(PROJECT_ENGINEERING_TAB, {
    variables: { id: projectId },
    skip: !projectId,
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  });

  const [localEngineering, setLocalEngineering] = useState<ProjectEngineeringGraphqlData | null>(null);
  useEffect(() => {
    setLocalEngineering(null);
  }, [data?.baseProject]);

  const engineering = localEngineering ?? data?.baseProject ?? null;

  if (loading) {
    return <Loading isInitialPosition />;
  }

  return (
    <ControlledShow data={engineering} setData={setLocalEngineering}>
      <Grid container spacing={2} sx={{ alignItems: 'stretch' }}>
        <Grid size={12} sx={{ display: 'flex' }}>
          <ConfigurationLayout />
        </Grid>
        {engineering?.engineeringPolicy?.productionOwnership === ProductionOwnership.OUR_TEAM && (
          <>
            <Grid size={12}>
              <IncidentCrudProvider projectId={projectId}>
                <IncidentsInProduction />
              </IncidentCrudProvider>
            </Grid>
            <Grid size={12}>
              <BugCrudProvider projectId={projectId}>
                <UserReportedBugs />
              </BugCrudProvider>
            </Grid>
          </>
        )}
      </Grid>
    </ControlledShow>
  );
};

export default EngineeringContext;
